module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0099.jpg?v=de1a9dbc";